import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as AtCliente } from '../images/atcliente.svg';
import { ReactComponent as App } from '../images/app.svg';
import { ReactComponent as Web } from '../images/web.svg';

const useStyles = makeStyles((theme) => ({

  footer: {   
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'fixed', 
    backgroundColor: '#fafafa',  
    bottom: '0',
    width:'100%',
    height:'80px'
},
footer_item: {   
  marginLeft: 'auto',
  marginRight: 'auto',
  backgroundColor: '#fafafa', 
  width:'100%',
  height:'100%'
},
}));


function Footer() {
  const classes = useStyles();
  
  return (
    <Grid container spacing={3}
    className={classes.footer}>    
      <Grid item xs={4}>
        <a className={classes.footer_item}  href="tel:959310310">
          <AtCliente className={classes.footer_item}/>
        </a>
      </Grid>
      <Grid item xs={4}>
        <a className={classes.footer_item}  href="https://play.google.com/store/apps/details?id=es.ingenia.giahsa.consumos&hl=es&gl=US">
          <App className={classes.footer_item}/>
        </a>
      </Grid>
      <Grid item xs={4}>
        <a className={classes.footer_item}  href="https://www.giahsa.com/" target="_blank" rel="noreferrer">
          <Web className={classes.footer_item}/>
        </a>
      </Grid>
    </Grid>
  );
}


export default Footer;